export default "__VITE_ASSET__BfbQR5vc__"